<template>
  <section class="myhome-con"
           v-if="isInit">
    <div class="tit-box type1">
      <h1 class="tit-type1">시설회원관리</h1>
      <div>
        <btn :txt="'회원초대'"
             :size="'small'"
             :color="'white'"
             @click="btnMberNvtn_click"/>
      </div>
    </div>
    <table class="tb-col">
      <colgroup>
        <col style="width:6%;" />
        <col style="width:auto;" />
        <col style="width:170px;" />
        <col style="width:170px;" />
        <col style="width:170px;" />
        <col style="width:170px;" />
      </colgroup>
      <thead>
      <tr>
        <th>번호</th>
        <th>회원명</th>
        <th>회원구분</th>
        <th>가입상태</th>
        <th>아이디</th>
        <th class="last">전화번호</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(mber, index) in fcltyMbers"
          :key="mber.mberSn">
        <td>{{ index+1 }}</td>
        <td class="__left">{{ mber.mberNm }}</td>
        <td>{{ mber.fcltyMberSenm }}</td>
        <td style="line-height: 25px;">{{ mber.fcltyMberSbsrStnm }}
          <btn v-if="mber.isSecsnPsbl"
               :txt="'탈퇴'"
               @click="btnSecsn_click(mber)"/>
        </td>
        <td>{{ mber.mberId }}</td>
        <td class="last">{{ mber.mbpnTlno }}</td>
      </tr>
      <tr v-if="fcltyMbers.length == 0">
        <td class="last"
            colspan="6">시설 회원이 존재하지 않습니다.</td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
import FcltyMberNvtn from '@/views/my-home/fclty-mber-nvtn.vue';

import {defineProps, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$popup, $axios,  $alert, $confirm, $cmmn} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true,
  }
});

/* 시설 회원 목록 */
const fcltyMbers = ref([]);
const getFcltyMbersByFcltySn = async () => {
  const {data: mbers} = await $axios.get('/api/fclty/mbers/by-fclty-sn', {params:{fcltySn: props.fcltySn}});

  mbers.forEach((mber) => {
    let isSecsnPsbl = false;
    if (mber.fcltyMberSecd == '200' && mber.fcltyMberSbsrStcd == '100') isSecsnPsbl = true;

    mber.isSecsnPsbl = isSecsnPsbl;
  });

  fcltyMbers.value = mbers;
}

const btnSecsn_click = async ({fcltySn, mberSn, fcltyMberRgstDt, mberNm}) => {
  try {
    $loading.on();

    const isConfirm = await $confirm(mberNm + '님을 탈퇴 처리 하시겠습니까?');
    if (!isConfirm) return false;

    const {data} = await $axios.post('/api/fclty/mber-secsn', {fcltySn, secsnMberSn: mberSn, fcltyMberRgstDt, mberSn: $mber.mberSn});
    if (data == 0) {
      await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
      return false;
    }

    await getFcltyMbersByFcltySn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const btnMberNvtn_click = () => {
  const popupOpts = {
    header: '시설 회원 초대',
    contentStyle: {
      'width': '400px'
    },
  }

  $popup.show(FcltyMberNvtn, popupOpts, props);
}

const isInit = ref(false);
onMounted(async () => {
  try {
    $loading.on();

    await getFcltyMbersByFcltySn();

    isInit.value = true;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
